// GridComponent.js
import React from 'react';

const StatsLevel = ({ items }) => {

  return (
    <div className="grid margin">
      <div className="item test Intelligence">
        Intelligence 
      </div>
      <div className="item Social">
        Social
      </div>
      <div className="item Observation">
        Observation
      </div>
      
      <div className="item IntelligenceFade">
        <span className="">{items.Intelligence}</span>      
      </div>
      <div className="item SocialFade">
        {items.Social}
      </div>
      <div className="item ObservationFade">
        {items.Observation}
      </div>
      
    </div>
  );
};


export default StatsLevel;
